export const assessmentQuestionsLengths = [12, 12, 12, 12, 12];

export const assessmentQuestionsAmount = assessmentQuestionsLengths.reduce((c, p) => c + p, 0);
